import { render, staticRenderFns } from "./bannerEdit.vue?vue&type=template&id=18c01bcf&scoped=true&lang=html"
import script from "./bannerEdit.vue?vue&type=script&lang=js"
export * from "./bannerEdit.vue?vue&type=script&lang=js"
import style0 from "./bannerEdit.vue?vue&type=style&index=0&id=18c01bcf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c01bcf",
  null
  
)

export default component.exports